import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <Link to="/" className="navbar-logo">
              <img src="/logo-icon-dark.svg" alt="IndiAds" width="28" height="28" style={{ borderRadius: '7px' }} />
              <span className="logo-text">Indi<span style={{ color: 'var(--accent)' }}>Ads</span></span>
            </Link>
            <p className="footer-tagline">
              India's #1 Meta Ads Swipe File for D2C performance marketers.
            </p>
          </div>

          <div className="footer-col">
            <p className="footer-col-title">Company</p>
            <Link to="/about" className="footer-link">About Us</Link>
            <Link to="/contact" className="footer-link">Contact Us</Link>
          </div>

          <div className="footer-col">
            <p className="footer-col-title">Legal</p>
            <Link to="/privacy" className="footer-link">Privacy Policy</Link>
            <Link to="/terms" className="footer-link">Terms &amp; Conditions</Link>
            <Link to="/refund-policy" className="footer-link">Refund &amp; Cancellation</Link>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copy">© {new Date().getFullYear()} IndiAds. Made with love in India.</p>
          <p className="footer-copy">For Indian D2C marketers, by Indian D2C marketers.</p>
        </div>
      </div>
    </footer>
  );
}
